import { render, staticRenderFns } from "./CUpload.vue?vue&type=template&id=61ade501&scoped=true&"
import script from "./CUpload.vue?vue&type=script&lang=js&"
export * from "./CUpload.vue?vue&type=script&lang=js&"
import style0 from "./CUpload.vue?vue&type=style&index=0&id=61ade501&lang=scss&scoped=true&"
import style1 from "./CUpload.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ade501",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/ctg-code/qihuibao-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VDialog,VIcon,VImg,VLayout,VList,VListTile,VListTileAction,VListTileContent,VListTileTitle})
